import classNames from "classnames";
import { LocalStorage } from "../../models/LocalStorage";
// eslint-disable-next-line no-unused-vars
import { Menu } from "../../models/Menu";
import { listenEvent, EVENTS } from "../../utils/event";
import { replaceVariable } from "../../utils/string";
import { DComponent } from "../DComponent";
import { MINI_APP } from "../../utils/miniApp";
import { urlFullFill } from "../../utils/url";
import { isMobile } from "../../utils/utils";

export default class MenuDropDown extends DComponent {
  constructor({
    parent,
    id,
    position = "right",
    menuItems = [],
    width = "188px"
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("MenuDropDown", position)
    }, true);
    /** @type {[Menu]} */
    this.menuItems = menuItems;
    this.width = width;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "MenuDropDown");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.parent.css("position", "relative");
    this.element.css("width", this.width);

    this.element.attr("country", LocalStorage.getShipping());
    let itemHtml = "", isActive = true, classElement = "";
    this.menuItems.forEach(menu => {
      if (!menu.hide) {
        itemHtml = ""; classElement = "";
        isActive = window.location.pathname.includes(menu.href);
        classElement = (menu.className ? " " + menu.className : "") + (isActive ? " active" : "");
        if (menu.isRedirect) {
          itemHtml = replaceVariable(require("html-loader!./itemRedirect.html"), {
            id: menu.id,
            url: menu.href,
            icon: menu.icon,
            iconHover: menu.iconHover,
            label: menu.label,
            class: classElement,
            follow: menu.isDofollow ? "dofollow" : "nofollow",
            country: menu.country ? `country="${menu.country}"` : "",
            locale: menu.lang ? `lang="${menu.lang}"` : "",
          })
        } else {
          itemHtml = replaceVariable(require("html-loader!./item.html"), {
            id: menu.id,
            icon: menu.icon,
            iconHover: menu.iconHover,
            label: menu.label,
            class: classElement,
            country: menu.country ? `country="${menu.country}"` : "",
            locale: menu.lang ? `lang="${menu.lang}"` : "",
          })
        }
        $(".box", this.element).append(itemHtml);
      }
    })

    this.menuItems.forEach(menu => {
      $("#" + menu.id, this.element).on("click", (e) => {
        menu.onClick && typeof menu.onClick === "function" && menu.onClick();
        this.hide();
      });

      $(`#${menu.id} a`, this.element).on("click", (e) => {
        if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
          e.preventDefault();
          MINI_APP.openPage({ url: urlFullFill($(e.currentTarget).attr("href")) });
        }
      });
    })

    this.setClass();

    listenEvent(EVENTS.CHANGE_LANGUAGE, (data) => {
      this.setClass({ lang: data });
    })

    listenEvent(EVENTS.CHANGE_COUNTRY, (data) => {
      this.setClass({ country: data });
    })

    listenEvent(EVENTS.CHANGE_AUTH_STATUS, () => {
      this.setClass();
    });

    $(document).on("click", (event) => {
      if (isMobile() && $(event.target).closest(this.parent).length === 0 && $(event.target).closest(this.element).length === 0) {
        this.hide();
      }
    });
  }

  setClass({ isLoggedIn = LocalStorage.isLoggedIn(), country = LocalStorage.getShipping(), lang = LocalStorage.getLanguage() } = {}) {
    let isCollaborator = LocalStorage.isCollaborator();
    $(".user-box-mobile", this.element).addClass(isLoggedIn ? "loggedin" : "unloggedin");
    $(`.menu-item`, this.element).each((i, obj) => {
      let c = $(obj).attr("country");
      let l = $(obj).attr("lang");
      let loggedin = $(obj).hasClass("required-loggedin");
      let collaborator = $(obj).hasClass("collaborator");
      let nocollaborator = $(obj).hasClass("none-collaborator");

      if (loggedin && !isLoggedIn) {
        $(obj).addClass("hide");
        return;
      }

      if (collaborator && !isCollaborator) {
        $(obj).addClass("hide");
        return;
      }

      if (nocollaborator && isCollaborator) {
        $(obj).addClass("hide");
        return;
      }

      if (c && c !== country) {
        $(obj).addClass("hide");
        return;
      }

      if (l && l !== lang) {
        $(obj).addClass("hide");
        return;
      }

      $(obj).removeClass("hide");
    })
  }

  show() {
    this.element.addClass("show");
  }

  hide() {
    this.element.removeClass("show");
  }
}